import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';
import hero from '../../assets/hero/yachtsafe-hero@2x-min.png';
import extraimg1 from '../../assets/frames/yachtsafe-extraimg1@2x-min.png';
import extraimg2 from '../../assets/frames/yachtsafe-extraimg2@2x-min.png';
import extraimg3 from '../../assets/frames/yachtsafe-extraimg3@2x-min.png';
import footerBanner from '../../assets/envImages/yachtsafe-footerBanner-min.jpg';

import env1 from '../../assets/envImages/yachtsafe-env1.jpg';
import env2 from '../../assets/envImages/yachtsafe-env2.jpg';

export default {
  path: '/cases/yachtsafe',
  color: variables.yachtsafe,
  quoteData: {
    quote: 'We needed someone who could completely revamp our service and rebuild it from scratch, as our old service was very outdated. All the way from design to the finished product in our hands, they have over-delivered on our expectations, and always stayed flexible when unforeseen circumstances have arrived. It\'s this type of partnership and service that we want from a tech partner, so We App will be building generation 2 of our product as well.',
    name: 'Joacim Vilhelmsson',
    profession: 'Co-Founder, Vetel AB',
  },
  hero: { fall: hero },
  xtraNoFrame: [
    { fall: extraimg1 },
    { fall: extraimg2 },
    { fall: extraimg3 },
  ],
  environments: { env1, env2 },
  footerBanner: { fall: footerBanner },
  title: 'Yachtsafe',
  sideHeadingFirst: 'iOS & Android application',
  sideHeadingSecond: 'Developed in React Native',
  infoTitle: 'What we built',
  infoBody:
  <span>
The best thing about it all, is that all of Yachtsafe's powerful features can be controlled easily from your mobile phone!
    <br />
    <br />
  We App helped Yachtsafe build a powerful mobile app that includes and supports a number of hardware devices. As such, vehicle owners can use the app to easily track and monitor everything from theft-alarm, temperature, battery level and voltage, to GPS live-tracking, and more.
    <br />
    <br />
  The mobile app was built in
    {' '}
    <Highlight>React Native</Highlight>
. With hosting and logic handled by
    {' '}
    <Highlight>GraphQL and NodeJS</Highlight>
. The customer has been so satisfied with the work We App has been performing, that We App has currently been tasked with building
    {' '}
    <Highlight>generation 2</Highlight>
    {' '}
of the service.

  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'A high-tech GPS-alarm system',
      body: <span>Yatchsafe is a modern surveillance and alarm system, offering live-tracking of vehicles. With its features, yatchsafe can keep the vehicle owners updated about anomalies in their vehicle condition. As well as offer live-surveillance and anti-theft measures. Yatchsafe is a tried and tested service, and over the years it has both prevented theft, and assisted the police in recovering millions of SEK worth in stolen property.</span>,
    },
  },
};
